module.exports = __webpack_public_path__ + "static/media/bg.396ec969.svg";